import { Outlet, useLocation } from 'react-router-dom'
import styles from './AppShell.module.css'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { BottomNav } from './BottomNav'
import { Toaster } from '../ui/Toaster'
import { SocketProvider } from '../../socket/SocketProvider'
import { NotificationsProvider } from '../../modules/notifications/NotificationsProvider'
import { FloatingChatWidget } from '../../modules/chat/FloatingChatWidget'

export function AppShell() {
  const location = useLocation()

  return (
    <SocketProvider>
      <NotificationsProvider>
        <div className={styles.shell}>
          <Sidebar />
          <div className={styles.main}>
            <Topbar />
            <div className={styles.content} key={location.pathname}>
              <Outlet />
            </div>
          </div>
          <BottomNav />
          <Toaster />
          {/* Nicht auf /chat selbst — dort läuft schon die volle Teamchat-Ansicht, ein
              zusätzliches schwebendes Fenster wäre redundant. */}
          {location.pathname !== '/chat' ? <FloatingChatWidget /> : null}
        </div>
      </NotificationsProvider>
    </SocketProvider>
  )
}
